import * as React from 'react';
import { Link } from 'react-router';
import { commonStingManagerManager } from '../../api/commonStingManagerManager';

import NewsCategory from '../../api/newsCategoryEntity';
import NewsItem from '../../api/newsItemEntity';


interface IProps {
    newsItems: NewsItem[];
    fetchWelcomePageNewsItems(): void;
}

export class WelcomePageNewsBlock extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchWelcomePageNewsItems();
  }

  public render() {
    return (
            <div className="row">
                {this.props.newsItems.map(WelcomePageNewsItem)}
            </div>
    );
  }
};

const WelcomePageNewsItem = (newsItem: NewsItem) => {
  return (
    <div className="col-md-4">
        <div className="box">
            <Link to={`/uutiset${newsItem.id}`} className="box-inner-wrap" tabIndex={-1}>
                <div className="box-image-wrap"><img alt="" src={newsItem.newsImage} /></div>
                <div className="box-content">
                    <span className="date">{commonStingManagerManager.formatDateToFiCulture(newsItem.publicationDate)}</span>
                 
                    <ul id="taglist">
                        {newsItem.categories && newsItem.categories.map(NewsCategoryItem)}
                    </ul>
                    <h3>{newsItem.title}</h3>
                </div>
            </Link>
        </div>
    </div>
  )
}

const NewsCategoryItem = (newsCategory: NewsCategory) => {
    return (
      <li>
        {newsCategory.title}
      </li>
    )
  }


// WEBPACK FOOTER //
// ./src/components/welcomePageNewsBlock/welcomePageNewsBlock.tsx